module.exports = __webpack_public_path__ + "static/media/connex.20200139.png";